export default __webpack_public_path__ + "alberta-fab-delete.11821834eba220f6541a.svg";